import React, { ReactNode } from "react";
import { api } from "api/api";
import MacroButton, {
  MacroBulletItem,
  MacroBulletList,
  MacroContentStack,
} from "./MacroButton.component";
import { DialogContentText } from "@mui/material";

export default function CreatePriceKeySubpropertyButton() {
  function InfoMessage(): ReactNode {
    return (
      <MacroContentStack>
        <DialogContentText>
          This process will add the .PRICEKEY subproperty to every property that
          has the .MLP subproperty for a product line. See additional details
          below:
        </DialogContentText>
        <MacroBulletList>
          <MacroBulletItem>
            The .PRICEKEY subproperty will not be added to a property that
            already has it. So this process can be run multiple times without
            any issues.
          </MacroBulletItem>
          <MacroBulletItem>
            .MLP subproperties that do not have the <strong>FLOAT</strong> data
            type will be ignored.
          </MacroBulletItem>
        </MacroBulletList>
        <DialogContentText>
          Are you sure you want to continue?
        </DialogContentText>
      </MacroContentStack>
    );
  }

  return (
    <MacroButton
      performApiCall={(productLineId: string) =>
        api.addPriceKeySubproperties(productLineId)
      }
      apiCallDependencies={[]}
      buttonLabel={`Add .PRICEKEY to Product Line`}
      dialogTitle={`Add .PRICEKEY to Product Line`}
      tooltipText={`Adds .PRICEKEY to the product line.`}
      processingMessage={`Adding .PRICEKEY to product line. This may take a while.`}
      completionMessage="Addition completed. See detailed results below."
      timeOutMessage="Addition process timed out. See details below."
      informationContent={InfoMessage()}
      timeOutFailureDescription={`Request timed out. This could be due to an especially large number of .PRICEKEY instances to add.`}
      pvasUpdated={false}
      recommendValidation={true}
    />
  );
}
